import TitleHeader from "@standard/components/TitleHeader";
import CustomerForm from "./CustomerForm";
import CustomerTable from "./CustomerTable";
import { Switch, Route, useRouteMatch } from "react-router-dom";

const programType = "Master";
const programName = "Customer";
const url = "master/customer";

export default function User({ history }) {
  const { path } = useRouteMatch();

  return (
    <>
      <TitleHeader programName={programName} programType={programType} />
      <Switch>
        <Route exact path={path}>
          <CustomerTable url={url} />
        </Route>
        <Route path={`${path}/:action/:id?`}>
          <CustomerForm history={history} url={url} />
        </Route>
      </Switch>
    </>
  );
}
